import * as React from 'react';
import { TimeLine } from '@mingcute/react';

import { cn } from '../lib/cn';

export interface TimePickerProps
  extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type'> {
  invalid?: boolean;
}

export const TimePicker = React.forwardRef<HTMLInputElement, TimePickerProps>(
  ({ className, invalid, disabled, ...props }, ref) => {
    return (
      <div
        className={cn(
          'flex h-9 items-center gap-2 rounded-[var(--radius-md)] border bg-[var(--color-surface)] px-3',
          'focus-within:ring-2 focus-within:ring-[var(--color-ring)]',
          invalid ? 'border-[var(--color-danger)]' : 'border-[var(--color-border)]',
          disabled && 'cursor-not-allowed opacity-60',
          className,
        )}
      >
        <TimeLine size={16} className="shrink-0 text-[var(--color-fg-muted)]" />
        <input
          ref={ref}
          type="time"
          disabled={disabled}
          aria-invalid={invalid || undefined}
          className="h-full flex-1 bg-transparent text-sm text-[var(--color-fg)] outline-none placeholder:text-[var(--color-fg-muted)] [color-scheme:dark]"
          {...props}
        />
      </div>
    );
  },
);
TimePicker.displayName = 'TimePicker';
